/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  HoldersListService,
  IHoldersListMethods,
  ILoadingMethods,
  LoadingService,
  StaticPageContentService,
  IStaticPageContentMethods,
  IInviteUserMethods,
  InviteUserService,
  IDeleteUserMethods,
  DeleteUserService,
  ISuspendUserMethods,
  SuspendUserService,
  HolderGroupsService,
  IHolderGroupsMethods,
} from "./components";

export type HoldersListPageAgent = IHeaderMethods &
  ISettingsMethods &
  ILoadingMethods &
  IStaticPageContentMethods &
  IInviteUserMethods &
  IHoldersListMethods &
  ISuspendUserMethods &
  IHolderGroupsMethods &
  IDeleteUserMethods;

const getPlugins = () => {
  return [
    new HeaderService(),
    new SettingsService(),
    new HoldersListService(),
    new LoadingService(),
    new StaticPageContentService(),
    new InviteUserService(),
    new DeleteUserService(),
    new SuspendUserService(),
    new HolderGroupsService(),
  ];
};

export const getAgent = () => {
  return createAgent<HoldersListPageAgent>({
    plugins: getPlugins(),
  });
};
